import React, { useState } from "react";
import { Badge, Dropdown, DropdownButton, Form } from "react-bootstrap";
import { CiSearch } from "react-icons/ci";
import { RxCross2 } from "react-icons/rx";
import { TbEqual, TbEqualDouble, TbMathGreater, TbMathLower } from "react-icons/tb";
export const HTMLEntities = (entityName) => {
    let htmlEntity;
    switch (entityName.toLowerCase()) {
        case "equal":
            htmlEntity = React.createElement(TbEqual, { size: 20 });
            break;
        case "strictEqual":
            htmlEntity = React.createElement(TbEqualDouble, { size: 20 });
            break;
        case "greater":
            htmlEntity = React.createElement(TbMathGreater, { size: 20 });
            break;
        case "less":
            htmlEntity = React.createElement(TbMathLower, { size: 20 });
            break;
        default:
            htmlEntity = null;
            break;
    }
    return htmlEntity;
};
const Filter = ({ colName, fieldName, type, possibleValue, compareSupport, filterInputs, setFiltersInput }) => {
    var _a, _b;
    const [input, setInput] = useState({ value: "", compareType: compareSupport[0] });
    const storeFiltersInputData = (
    // { value, field?, compareType }: { value?: string, field: string, compareType?: string }
    ) => {
        var _a;
        const existedValue = (_a = filterInputs[fieldName]) === null || _a === void 0 ? void 0 : _a.find((element) => (element.value === input.value.trim() && element.compareType === input.compareType));
        if (!fieldName || existedValue)
            return;
        setFiltersInput((prevInput) => {
            var _a;
            const updatedValues = ((_a = prevInput[fieldName]) === null || _a === void 0 ? void 0 : _a.length) ? prevInput[fieldName] : [];
            if (input.value)
                updatedValues.push({ value: input.value.trim(), compareType: input.compareType || compareSupport[0] });
            return Object.assign(Object.assign({}, prevInput), { [fieldName]: updatedValues });
        });
    };
    const removeFilterInputValue = (fieldNameKey, valueToBeRemoved) => {
        if (!fieldNameKey)
            return;
        const oldInputsMeta = filterInputs[fieldNameKey];
        if (!(oldInputsMeta === null || oldInputsMeta === void 0 ? void 0 : oldInputsMeta.length))
            return;
        setFiltersInput((prevInput) => {
            return Object.assign(Object.assign({}, prevInput), { [fieldNameKey]: [...oldInputsMeta.filter((oldMeta) => oldMeta.value !== valueToBeRemoved)] });
        });
    };
    let filterJsxElement;
    switch (type.toLowerCase()) {
        case "dynamic":
            filterJsxElement = React.createElement(React.Fragment, null,
                React.createElement("div", { className: "d-flex gap-2 mb-2" },
                    React.createElement("div", null,
                        React.createElement(DropdownButton, { variant: "light", size: "sm", id: "dropdown-basic-button", title: HTMLEntities(input.compareType || ((_a = compareSupport[0]) !== null && _a !== void 0 ? _a : "equal")), className: "compare-dropdown border rounded", drop: "down-centered" }, compareSupport.map((compType, supportIndex) => {
                            return (React.createElement(Dropdown.Item, { key: supportIndex, value: compType, href: "#", onClick: () => {
                                    setInput((prevInput) => (Object.assign(Object.assign({}, prevInput), { compareType: compType })));
                                } }, HTMLEntities(compType)));
                        }))),
                    React.createElement("div", { className: "input-group p-0" },
                        React.createElement("span", { className: "input-group-append" },
                            React.createElement("div", { className: "bg-white border-end-0 border h-100 pt-1 ps-1" },
                                React.createElement(CiSearch, { size: 30 }))),
                        React.createElement("input", { className: "form-control py-2 border-start-0 border", type: "search", placeholder: `Enter ${colName.toLowerCase()}`, title: `Enter ${colName.toLowerCase()} and press enter`, value: input.value, id: "example-search-input", onChange: (e) => {
                                setInput((prevInput) => (Object.assign(Object.assign({}, prevInput), { value: e.target.value })));
                            }, onKeyDown: (keyPressEvent) => {
                                if ((keyPressEvent === null || keyPressEvent === void 0 ? void 0 : keyPressEvent.key) === "Enter") {
                                    storeFiltersInputData();
                                }
                            } }))),
                React.createElement("div", { className: "mt-4" }, (_b = filterInputs[fieldName]) === null || _b === void 0 ? void 0 : _b.map(({ value }, valueIndex) => {
                    return (React.createElement("div", { key: valueIndex, className: "m-2 d-inline-flex" },
                        React.createElement(Badge, { bg: "primary", className: "px-2 py-1" },
                            value,
                            React.createElement(RxCross2, { className: "ms-2 cursor-pointer", size: 20, onClick: () => removeFilterInputValue(fieldName, value) }))));
                })));
            break;
        case "fixed":
            filterJsxElement = (possibleValue === null || possibleValue === void 0 ? void 0 : possibleValue.length) ?
                React.createElement("div", { className: "row gap-4 d-flex justify-content-evenly" }, possibleValue.map((possiblevalue, index) => {
                    var _a;
                    const active = (_a = filterInputs[fieldName]) === null || _a === void 0 ? void 0 : _a.some(({ value }) => value === possiblevalue);
                    return (React.createElement("div", { key: index, className: `col-lg-5 cursor-pointer possible-value-card ${active && "active"}`, onClick: () => {
                            if (active)
                                removeFilterInputValue(fieldName, possiblevalue);
                            else {
                                // if (filterInputs[fieldName]?.find((element) => element.value === possiblevalue )) return;
                                setFiltersInput((prevInput) => {
                                    var _a;
                                    const updatedValues = ((_a = prevInput[fieldName]) === null || _a === void 0 ? void 0 : _a.length) ? prevInput[fieldName] : [];
                                    updatedValues.push({ value: possiblevalue.trim(), compareType: compareSupport.length ? compareSupport[0] : "strictEqual" });
                                    return Object.assign(Object.assign({}, prevInput), { [fieldName]: updatedValues });
                                });
                            }
                        } },
                        React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                            React.createElement("div", { title: possiblevalue, className: "text-truncate possible-value-div" }, possiblevalue),
                            React.createElement(Form.Check, { type: "radio", checked: active, readOnly: true }))));
                })) : null;
            break;
        default:
            filterJsxElement = null;
            break;
    }
    return (filterJsxElement);
};
export default Filter;
